<template>
  <div id="app">
    <first-Component></first-Component>
    <div id="scroller-wrapper" data-scrollbar >
      <div class="donghua"  :style="noShow">

      </div>
    <router-view/>
    </div>
  </div>
</template>

<script>
  import  {WOW} from 'wowjs'
  import Scrollbar from 'smooth-scrollbar';
  import firstComponent from './components/first'
  export default {
    name: 'App',
    data(){
      return{
        noShow:{},
        wow:'',
        scrollbar:''
      }
    },
    watch:{
      '$route':'init'
    },
    components:{firstComponent},
    mounted() {
      this.wow=new WOW();
      this.init()
      if(this.$i18n.locale==='en')
      {
        document.title="NINGBO YOUR LONG LIGHTING CO,.LTD.    NINGBO YOUR TRUST IMPORT & EXPORT CO,. LTD."
      }else{
        document.title="宁波有容照明有限公司"
      }
      this.$router.beforeEach((to, from, next) => {
        Scrollbar.destroyAll()
        next()
      })
    },
    methods:{
      init(){
        this.$nextTick(()=>{
          this.scrollbar = Scrollbar.init(document.getElementById('scroller-wrapper'));
          this.wow.init()
          this.noShow={display:'block'}
          let scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
          scrollbar.scrollTo(0,0)
          window.pageYOffset=this.scrollbar.scrollTop
          this.scrollbar.addListener(() => {
            this.wow.scrollHandler()
            window.pageYOffset=this.scrollbar.scrollTop
            if(window.pageYOffset>0){
              this.noShow={display:'none'}
            }
          });
        })
      }
    }
  }
</script>

<style>
  .v-modal{
    display: none !important;
  }
  body{
    margin:0;
    padding: 0;
  }
  a{
    text-decoration: none;
    color:black;
  }
  .viewer-canvas>img{
    margin-top: 150px !important;
  }
  .el-carousel__button{
    height:10px !important;
    width:10px !important;
    border-radius: 50% !important;
    background-color: #F4A000 !important;
  }
  .donghua{
    height:0;
    width:100%;
    position: absolute;
    top:0;
    left:0;
    z-index: 999;
    color:white;
    background-color: black;
    animation: change 600ms linear;
  }
  @keyframes change {
    from{
     height:100vh;
    }
    to{
      height:0;
    }
  }
#app {
  font-family:Calibri;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
 color:black;
  width:100%;
  overflow: hidden;
}
  #scroller-wrapper{
    position: relative;
    height: 100vh;
    overflow: hidden;
    /* z-index: 101; */
  }
  .scrollbar-thumb{
    width:3px !important;
    background-color: #C7000C !important;
  }
  .scrollbar-track-y{
    width:3px !important;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  @media screen and (max-width:450px){
    .el-dialog{
      width:90% !important;
    }
  }
</style>
